
namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    export class PsCorperateMessageGrid extends Serenity.EntityGrid<PsCorperateMessageRow, any> {
        protected getColumnsKey() { return PsCorperateMessageColumns.columnsKey; }
        protected getDialogType() { return PsCorperateMessageDialog; }
        protected getIdProperty() { return PsCorperateMessageRow.idProperty; }
        protected getInsertPermission() { return PsCorperateMessageRow.insertPermission; }
        protected getLocalTextPrefix() { return PsCorperateMessageRow.localTextPrefix; }
        protected getService() { return PsCorperateMessageService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}